import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { Row } from 'elc-grid';
import { ProductPromoMessageTheme } from '../../../theme/default-theme';
import { Body2 } from 'elc-typography';

export interface IPromoMessage {
    className?: string;
    promoMessage: string;
}

const PromoMessage = styled(Row)`
    width: 100%;
    margin: ${ContentSpacing.space16} ${ContentSpacing.space8} 0;
    padding: ${ContentSpacing.space16} ${ContentSpacing.space12};
    border-radius: ${ContentSpacing.space4};
    ${ProductPromoMessageTheme};
`;

export const ProductPromoMessage = (props: IPromoMessage) => {
    const productPromoMessageClassNames = classnames(
        'elc-product-promo-message',
        'js-product-promo-message'
    );

    return (
        <PromoMessage className={productPromoMessageClassNames}>
            <Body2>{props.promoMessage}</Body2>
        </PromoMessage>
    );
};
